var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(1903 758) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    transform: "translate(1832 687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios-24px",
    transform: "translate(1896.821 751.497) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M0,0H58.319V58.318H0Z",
    fill: "none",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M25.2.893a3.036,3.036,0,0,0-4.3,0L.711,21.085a2.42,2.42,0,0,0,0,3.426L20.9,44.7a3.041,3.041,0,0,0,4.3-4.3L7.612,22.786,25.229,5.17A3.029,3.029,0,0,0,25.2.893Z",
    transform: "translate(15.181 6.372)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryLeftArrow);
export default __webpack_public_path__ + "static/media/category-left-arrow.575eda2921f0524ac4187dd2f048d85f.svg";
export { ForwardRef as ReactComponent };